import React from 'react';

import { isEmpty } from 'ramda';

import { ETripEvent } from 'detailsv2/structure';

import { useTripEventDefaultValuesQuery } from '../../../TripEventModalContents/shared/useTripEventDefaultValues/useTripEventDefaultValuesQuery';
import { useAccomodationWizardContext } from '../../context';
import { usePropertyPageQuery } from '../../hooks';
import { TFormValues } from '../types';
import { useAccomodationFormContext } from './useAccomodationFormContext';

export const useDefaultValues = () => {
  const { createdRooms, setCreatedRooms } = useAccomodationWizardContext();
  const {
    methods: { formState, watch, setValue, getValues },
    isEditing,
  } = useAccomodationFormContext();

  const attachedPage = watch('attachedPage');

  // TODO: refactor type system
  const defaultValuesQueryRes = useTripEventDefaultValuesQuery(attachedPage as never, ETripEvent.Accommodation);
  const propertyPageQueryRes = usePropertyPageQuery({ pageId: attachedPage?.id });

  React.useEffect(() => {
    if (isEditing && !formState.touchedFields.attachedPage) return;
    if (!defaultValuesQueryRes.data) return;
    const data = defaultValuesQueryRes.data.data?.defaultValues?.data as TFormValues['data'];
    const icon = defaultValuesQueryRes.data.data?.defaultValues?.icon;
    if (!data) return;
    const customRooming = data.rooming.map((roomingItem) => ({
      ...roomingItem,
      label: roomingItem.name || '',
      value: roomingItem.id || '',
    }));
    if (customRooming) setCreatedRooms(customRooming);
    if (icon) setValue('icon', icon);
    setValue('data', data);
    setValue('data.rooming', customRooming);
    setValue('data.notes', data.notes);
  }, [defaultValuesQueryRes.data]);

  React.useEffect(() => {
    if (!propertyPageQueryRes.data) return;
    if (!propertyPageQueryRes.isValidPropertyPage) return;
    if (defaultValuesQueryRes.data) return;
    const createdRoomsValues = createdRooms.map((room) => room.value);
    const rooming = getValues().data.rooming;
    if (isEmpty(createdRoomsValues)) return;
    const handledRooming = rooming.filter((roomingItem) => createdRoomsValues.includes(roomingItem.value));
    setValue('data.rooming', handledRooming);
  }, [propertyPageQueryRes.data, defaultValuesQueryRes.data]);
};
